<script setup>
import ApikomTaskForm from '@frontJs/components/forms/projectManagement/tasks/ApikomTaskForm.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import PageTitle from '@js/components/titles/PageTitle.vue';

const {
    task,
    taskTypes,
    taskRecurrentTypes,
    taskThemes,
    taskStatuses,
    taskPriorities,
    tenants,
    users,
} = defineProps({
    task: {
        type: Object,
        required: false,
    },
    taskTypes: {
        type: Array,
        required: true,
    },
    taskRecurrentTypes: {
        type: Array,
        required: true,
    },
    taskThemes: {
        type: Array,
        required: true,
    },
    taskStatuses: {
        type: Array,
        required: true,
    },
    taskPriorities: {
        type: Array,
        required: true,
    },
    tenants: {
        type: Array,
        required: true,
    },
    users: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title v-if="task">
            Mettre à jour une tâche Apikom #{{ task.id }} - Tâches - Gestion de
            projet - Datakepler
        </title>

        <title v-else>
            Créer une tâche Apikom - Tâches - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle v-if="task">
        Gestion de projet - Tâches - Mettre à jour une tâche Apikom #{{
            task.id
        }}
    </PageTitle>

    <PageTitle v-else>
        Gestion de projet - Tâches - Créer une tâche Apikom
    </PageTitle>

    <ApikomTaskForm
        :task="task"
        :task-types="taskTypes"
        :task-recurrent-types="taskRecurrentTypes"
        :task-themes="taskThemes"
        :task-statuses="taskStatuses"
        :task-priorities="taskPriorities"
        :tenants="tenants"
        :users="users"
    />
</template>
